import axiosInternal from '@/libs/axios-internal'

/**
 * Serviço para gerenciar notificações via API REST
 * Base URL: /internal/v1/notifications
 *
 * Formato de resposta:
 * {
 *   unread_count: number,
 *   data: {
 *     current_page: number,
 *     data: Array<Notification>,
 *     total: number,
 *     per_page: number,
 *     ...
 *   }
 * }
 */
const notificacoesService = {
  /**
   * Listar notificações do usuário
   * @param {Object} params - Parâmetros de filtro
   * @param {string} params.status - 'all' ou 'unread' (padrão: 'all')
   * @param {string} params.type - Tipo da notificação (opcional)
   * @param {number} params.per_page - Itens por página, 1-100 (padrão: 20)
   * @param {number} params.page - Página (padrão: 1)
   * @returns {Promise} Retorna { unread_count, data: { data: Array, ...paginacao } }
   */
  async listar(params = {}) {
    // eslint-disable-next-line no-useless-catch
    try {
      // Validar parâmetros conforme especificação da API
      const validParams = {}

      if (params.status) {
        if (['all', 'unread'].includes(params.status)) {
          validParams.status = params.status
        }
      }

      if (params.type) {
        validParams.type = params.type
      }

      if (params.per_page) {
        const perPage = Math.min(Math.max(parseInt(params.per_page, 10), 1), 100)
        validParams.per_page = perPage
      }

      if (params.page) {
        validParams.page = parseInt(params.page, 10)
      }

      const response = await axiosInternal.get('/notifications', { params: validParams })

      // Normalizar resposta: garantir que sempre retorna { unread_count, data }
      return {
        unread_count: response.data.unread_count || 0,
        data: response.data.data || response.data,
      }
    } catch (error) {
      throw error
    }
  },

  /**
   * Marcar notificação como lida
   * @param {string} notificationId - UUID da notificação
   * @returns {Promise}
   */
  async marcarComoLida(notificationId) {
    // eslint-disable-next-line no-useless-catch
    try {
      const response = await axiosInternal.post(`/notifications/${notificationId}/read`)
      return response.data
    } catch (error) {
      throw error
    }
  },

  /**
   * Marcar todas as notificações como lidas
   * @returns {Promise}
   */
  async marcarTodasComoLidas() {
    // eslint-disable-next-line no-useless-catch
    try {
      const response = await axiosInternal.post('/notifications/read-all')
      return response.data
    } catch (error) {
      throw error
    }
  },
}

export default notificacoesService
